export default __webpack_public_path__ + "static/media/flecha-abajo-responsive-mantenimiento.d5128fa5.svg";